import { render, staticRenderFns } from "./openApp.vue?vue&type=template&id=01f4ff3b&scoped=true"
import script from "./openApp.vue?vue&type=script&lang=js"
export * from "./openApp.vue?vue&type=script&lang=js"
import style0 from "./openApp.vue?vue&type=style&index=0&id=01f4ff3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4ff3b",
  null
  
)

export default component.exports